export const showHideLanguage = () => {
    // Language (Desktop)
    $('#lang-picker').on('click', function () {
        const dropdownMenu = $('.header-v3-lang-dropdown.tectrain-dropdown-menu');
        dropdownMenu.toggleClass('visible');

        dropdownMenu.toggle(200);

        if (dropdownMenu.hasClass('visible')) {
            $('body').attr('lang-menu-on', '');
        } else {
            $('body').removeAttr('lang-menu-on');
        }
    });

    $('#user-menu').on('click', function () {
        const dropdownMenu = $('.header-v3-user-menu-dropdown.tectrain-dropdown-menu');
        dropdownMenu.toggleClass('visible');

        dropdownMenu.toggle(200);

        if (dropdownMenu.hasClass('visible')) {
            $('body').attr('lang-menu-on', '');
        } else {
            $('body').removeAttr('lang-menu-on');
        }
    });
};
